// getEnv returns the value of an environment variable.
// Either provided by the typical VUE_APP_* environment variables from file,
// or by the injected configuration at deploy time
export function getEnv (key) {
  return process?.env?.[key] || window?.env?.[key] || null
}

export const HELPDESK = {
  telephone: getEnv('VUE_APP_CONTACT_TELEPHONE') || '1800 111 672',
  email: getEnv('VUE_APP_CONTACT_EMAIL') || 'msaenquiries@mla.com.au'
}

export const APP_ENTRYPOINT = 'appEntrypoint'

export const LICENSE_AGREEMENT_GENERIC = new URL('/license-agreements/TermsConditions_MLAGeneric_20220303.pdf', document.baseURI).href

export const contactInformation = {
  mlaName: 'Meat and Livestock Australia',
  msaName: 'Meat Standards Australia',
  mlaBusinessName: 'Meat and Livestock Australia Limited',
  mlaAbn: '39 081 678 364',
  msaPostalAddress: 'PO Box 2363 FORTITUDE VALLEY BC QLD 4006',
  msaEmailAddress: 'msaenquiries@mla.com.au',
  msaWebsite: 'www.mla.com.au/msa',
  msaPhone: '1800 111 672',
  msaPhoneAlt: '(07) 3620 5200',
  msaFax: '(07) 3620 5250'
}
